import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-669e6d04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-background fade-in" }
const _hoisted_2 = { class: "flex justify-end mb-2 flex-shrink-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, "Modal sin contenido", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-container", [_ctx.customClass]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "text-primary top-4 right-4",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, " ✕ ")
      ]),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_3
      ], true)
    ], 2)
  ]))
}